// ABOUTME: Live's up and down buttons around the product gallery's thumbnail rail (MC-23), on products with more than five images.
// Each product gallery's thumbnail list gets live's chevron buttons above and below it; a click scrolls the list three thumbnails (live's
// data-step 3), and the rail notes whether more thumbnails sit above or below (live's fades). The rail shows from 1280px (CSS in
// snippets/jf-product-information-layout-styles.liquid); the buttons are added again whenever the gallery re-renders (a variant pick).

const CHEVRON_UP =
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
  '<path fill="#393536" d="m18.667 14.65-1.184 1.183L12 10.35l-5.483 5.483-1.184-1.183L12 7.983l6.667 6.667Z"/></svg>';
const CHEVRON_DOWN =
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
  '<path fill="#393536" d="m18.667 9.35-1.184-1.183L12 13.65 6.517 8.167 5.333 9.35 12 16.017l6.667-6.667Z"/></svg>';

/* Live renders its buttons only when a product has more than five images, and moves the list three thumbnails per click. */
const MIN_THUMBNAILS = 6;
const STEP_THUMBNAILS = 3;
const RAIL = '.product-information__media slideshow-controls[thumbnails]';

/**
 * Adds the two buttons to one gallery's thumbnail controls, once.
 * @param {HTMLElement} controls - The gallery's slideshow-controls[thumbnails] element
 */
function addButtons(controls) {
  if (controls.querySelector(':scope > .jf-thumbnail-arrow')) return;
  const list = controls.querySelector('.slideshow-controls__thumbnails-container');
  if (!list) return;
  const thumbnails = list.querySelectorAll('.slideshow-controls__thumbnail');
  if (thumbnails.length < MIN_THUMBNAILS) return;

  const update = () => {
    controls.classList.toggle('jf-thumbnail-rail--has-previous', list.scrollTop > 0);
    controls.classList.toggle('jf-thumbnail-rail--has-next', list.scrollTop + list.clientHeight < list.scrollHeight - 1);
  };
  const button = (direction) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = `jf-thumbnail-arrow jf-thumbnail-arrow--${direction}`;
    b.setAttribute('aria-label', direction === 'previous' ? 'Scroll thumbnails up' : 'Scroll thumbnails down');
    b.innerHTML = direction === 'previous' ? CHEVRON_UP : CHEVRON_DOWN;
    b.addEventListener('click', () => {
      const first = thumbnails[0];
      const gap = parseFloat(getComputedStyle(first.parentElement).rowGap) || 0;
      const step = (first.getBoundingClientRect().height + gap) * STEP_THUMBNAILS;
      list.scrollBy({ top: direction === 'previous' ? -step : step, behavior: 'smooth' });
    });
    return b;
  };

  controls.classList.add('jf-thumbnail-rail--arrows');
  controls.prepend(button('previous'));
  controls.append(button('next'));
  list.addEventListener('scroll', update, { passive: true });
  new ResizeObserver(update).observe(list);
  update();
}

const addAll = () => document.querySelectorAll(RAIL).forEach((controls) => addButtons(/** @type {HTMLElement} */ (controls)));

let pending = false;
new MutationObserver(() => {
  if (pending) return;
  pending = true;
  requestAnimationFrame(() => {
    pending = false;
    addAll();
  });
}).observe(document.documentElement, { childList: true, subtree: true });

addAll();
